import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const FilingRuleFrame = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        FilingRule Frame
      </Typography>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Typography>
          This is the FilingRuleFrame component. Replace this with your actual
          UI.
        </Typography>
      </Paper>
    </Box>
  );
};

export default FilingRuleFrame;
